var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemoveV2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  fill: "none",
  stroke: "currentColor"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1864_113076",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 5,
  width: 22,
  height: 22
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 22,
  height: 22,
  fill: "currentColor"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1864_113076)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.508 21.7752C11.1536 22.1295 10.5791 22.1295 10.2247 21.7752V21.7752C9.87029 21.4208 9.87029 20.8462 10.2247 20.4918L14.7163 16.0002L10.2247 11.5085C9.87029 11.1541 9.87029 10.5795 10.2247 10.2252V10.2252C10.5791 9.87078 11.1536 9.87078 11.508 10.2252L15.9997 14.7168L20.4913 10.2252C20.8457 9.87078 21.4203 9.87078 21.7747 10.2252V10.2252C22.1291 10.5795 22.1291 11.1541 21.7747 11.5085L17.283 16.0002L21.7747 20.4918C22.1291 20.8462 22.1291 21.4208 21.7747 21.7752V21.7752C21.4203 22.1295 20.8457 22.1295 20.4913 21.7752L15.9997 17.2835L11.508 21.7752Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemoveV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/removeV2.76c61658920b8512e245ec4f8972067b.svg";